// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import React from "react";

const ReturnPolicy: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.135" height="22.62">
            <path
                fill="#212121"
                fillRule="evenodd"
                d="M1.825 22.266a.75.75 0 1 1-1.275-.792l2.818-4.534H2.89a2.864 2.864 0 0 1-2.879-2.672l-.006-.169V11.94a.625.625 0 0 1 1.25 0v2.167c.017.892.754 1.6 1.646 1.583h1.243l5.749-9.25H2.132l.43.428L3.7 7.996a.628.628 0 0 1-.89.889L.182 6.255a.625.625 0 0 1 .004-.884l2.63-2.63a.625.625 0 0 1 .884.004c.248.25.246.646.001.889L2.563 4.763l-.431.427h8.538L13.675.354a.75.75 0 1 1 1.275.792L12.435 5.19h.804a2.866 2.866 0 0 1 2.885 2.673l.006.168v2.16a.625.625 0 0 1-1.25 0V8.023a1.615 1.615 0 0 0-1.646-1.584h-1.576L5.91 15.69h8.093l-.43-.427-1.142-1.133a.627.627 0 0 1 .009-.889.625.625 0 0 1 .884.004l2.63 2.63a.625.625 0 0 1-.004.884l-2.625 2.626a.629.629 0 0 1-.89-.89l1.137-1.127.431-.428h-8.87l-3.308 5.326Z"
            />
        </svg>
    );
};

export const ReturnPolicyOffset: IconOffset = {
    vertical: 10,
    horizontal: 6,
};

export default React.memo(ReturnPolicy);
